import React from 'react';
import { BatteryWarning, CheckCircle2 } from 'lucide-react';
export function ProblemSolution() {
  return <section className="py-8 md:py-16 px-4 bg-dark-900 border-t border-dark-800" data-id="element-67">
      <div className="max-w-4xl mx-auto" data-id="element-68">
        {/* The Problem */}
        <div className="text-center mb-10 md:mb-16" data-id="element-69">
          <h2 className="text-2xl md:text-5xl font-black mb-6 md:mb-8 text-white leading-tight" data-id="element-70">
            La parte más difícil de enseñar Programación no es conocer la
            materia…{' '}
            <span className="highlight-yellow text-white block md:inline mt-2 md:mt-0" data-id="element-71">
              es lograr que los alumnos entiendan los conceptos.
            </span>
          </h2>

          <p className="text-base md:text-2xl text-gray-300 mb-6 font-medium" data-id="element-72">
            Si enseñas programación seguramente te pasó más de una vez: explicás
            variables, algoritmos, estructuras de control, funciones, bases de
            datos... y aun así muchos estudiantes siguen sin comprender
            realmente qué está pasando.
          </p>

          <p className="text-base md:text-2xl text-gray-300 mb-6 md:mb-10 font-medium" data-id="element-73">
            Entonces tenés que:
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4 text-left max-w-2xl mx-auto mb-8 md:mb-12" data-id="element-74">
            {['buscar nuevos ejemplos', 'simplificar explicaciones', 'crear materiales extra', 'armar nuevas actividades', 'hacer esquemas', 'volver a explicar desde otro enfoque'].map((item, i) => <div key={i} className="flex items-center gap-2 md:gap-3 bg-red-900/20 p-3 md:p-4 rounded-lg border border-red-900/50" data-id="element-75">
                <BatteryWarning className="text-red-400 shrink-0 w-5 h-5 md:w-6 md:h-6" data-id="element-76" />
                <span className="font-semibold text-gray-200 text-sm md:text-lg" data-id="element-77">
                  {item}
                </span>
              </div>)}
          </div>

          <p className="text-lg md:text-2xl font-bold text-white mb-2 md:mb-4" data-id="element-78">
            Y mientras más cursos tenés…
          </p>
          <p className="text-xl md:text-3xl font-black text-red-400 uppercase" data-id="element-79">
            más tiempo invertís preparando material y menos tiempo te queda para
            enseñar.
          </p>
        </div>

        {/* The Transition / Solution */}
        <div className="bg-dark-800 border-2 border-brand-500/30 rounded-2xl p-6 md:p-12 text-center shadow-lg" data-id="element-80">
          <h3 className="text-lg md:text-2xl font-bold mb-4 text-gray-300" data-id="element-81">
            Necesitas una forma más simple de enseñar Programación.
          </h3>

          <div className="w-16 md:w-24 h-1 bg-brand-500 mx-auto my-6 md:my-8" data-id="element-82"></div>

          <p className="text-base md:text-xl font-medium mb-2 md:mb-4 text-gray-400" data-id="element-83">
            Por eso creamos el
          </p>
          <h2 className="text-2xl md:text-5xl font-black text-brand-400 mb-6 md:mb-8 uppercase leading-tight" data-id="element-84">
            Manual Académico de Programación para Docentes
          </h2>

          <p className="text-lg md:text-3xl font-black text-brand-300 mb-4 md:mb-8" data-id="element-85">
            No es material suelto. Es una forma sencilla de explicar
            Programación.
          </p>
          <p className="text-base md:text-xl mb-6 md:mb-8 text-gray-300" data-id="element-86">
            Un manual académico completo que transforma conceptos complejos en
            contenidos fáciles de comprender para los estudiantes. Porque cuando
            las explicaciones son más claras:
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4 max-w-2xl mx-auto text-left" data-id="element-87">
            {['Los alumnos entienden más rápido', 'Participan más', 'Hacen menos consultas repetitivas', 'Relacionan mejor los conceptos', 'Aprenden con mayor seguridad'].map((item, i) => <div key={i} className="flex items-center gap-2 md:gap-3 bg-dark-900 p-3 md:p-4 rounded-lg border border-dark-700 shadow-sm" data-id="element-88">
                <CheckCircle2 className="text-brand-400 shrink-0 w-5 h-5 md:w-6 md:h-6" data-id="element-89" />
                <span className="font-bold text-sm md:text-lg text-gray-200" data-id="element-90">
                  {item}
                </span>
              </div>)}
          </div>

          <p className="mt-6 md:mt-8 text-base md:text-lg font-bold text-brand-400 uppercase tracking-widest" data-id="element-91">
            Y el docente puede enfocarse en enseñar en lugar de pasar horas
            creando material.
          </p>
        </div>
      </div>
    </section>;
}